import listCellService from '../directives/fb-grid/types/listCell/list.cell.service';
import templateCellService from '../directives/fb-grid/types/template.cell.service';
import arrayCellService from '../directives/fb-grid/types/array.cell.service';
import objectCellService from '../directives/fb-grid/types/object.cell.service';
import popupFieldCellService from '../directives/fb-grid/types/popup-field.cell.service';
import hiddenCellService from '../directives/fb-grid/types/hidden.cell.service';
import groupcolumnCellService from '../directives/fb-grid/types/groupcolumnCell/groupcolumn.cell.service';

export const CELLS = {
  list: listCellService,

  array: arrayCellService,
  group: arrayCellService,

  object: objectCellService,

  string: templateCellService,
  text: templateCellService,
  number: templateCellService,
  percent: templateCellService,
  select: templateCellService,
  dateTime: templateCellService,
  date: templateCellService,
  time: templateCellService,

  textarea: popupFieldCellService,

  hidden: hiddenCellService,
  // inputSelectConcat: inputSelectConcatService,
  // label: labelService,
  // script: scriptService,
  // selectIcon: selectIconService,
  groupcolumn: groupcolumnCellService,
};
